<template>
  <div class="rise-pg">
    <progress-bar/>

    <span class="form-title">What is the rise?</span>
    <span class="form-input-sub-label">“Rise” describes how high the trousers sit at the waist.</span>

    <div class="img-select-form">
      <div class="img-select no-ml" :class="{active: selection === -1}">
        <div class="img-container first" @click="setSelection(-1)"></div>
        <span class="centered-vertically">Low</span>
      </div>

      <div class="img-select" :class="{active: selection === 0}">
        <div class="img-container second" @click="setSelection(0)"></div>
        <span class="centered-vertically">Average</span>
      </div>

      <div class="img-select" :class="{active: selection === 1}">
        <div class="img-container third" @click="setSelection(1)"></div>
        <span class="centered-vertically">High</span>
      </div>
    </div>

    <navigation/>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import Navigation from "../../Navigation";
import FitPreferenceMixin from "../../../mixins/FitPreferenceMixin";

export default {
  name: "RiseView",

  mixins: [FitPreferenceMixin],

  data() {
    return {
      type: 'rise',
      default: 0,
    };
  },

  components: {Navigation, ProgressBar},
};
</script>
